import { Builder } from '@builder.io/react';

import SubsidyCalculator from './subsidy-calculator';

Builder.registerComponent(SubsidyCalculator, {
  name: 'SubsidyCalculator',
  inputs: [
    { name: 'title', type: 'text' },
    { name: 'subtitle', type: 'text' },
    { name: 'logo', type: 'file', allowedFileTypes: ['jpeg', 'png', 'svg'] },
  ],
  noWrap: false,
});
